import type { Match, Query } from '@atlassian/react-resource-router';

export const getBoardId = (match: Match, query: Query) =>
	match.params.boardId || query.rapidView || query['board.id'];
